<template>
  <div
    class="d-flex flex-column"
    :class="$store.state.screenMode === 'dark' ? 'dark' : ''"
  >
    <section class="m-3 fullContainerSelectedItem">
      <div class="m-4 mobileWidth">
        <!--GOOGLE & TOOLBOX SEARCH-->
        <section class="d-flex justify-content-between mb-3 searchSection">
          <!--Toolbox Search-->
          <GoogleSearchComponent />
          <div class="toolboxSearchContainer">
            <input
              id="searchBtn"
              type="search"
              placeholder="Zoek in Marketing Toolbox ..."
              v-model="searchedString"
              @input="onSearchChange"
            /><i class="fa-light fa-magnifying-glass nl-3"></i>
          </div>

          <!--TODO: Create working Google search -->
          <!-- <div class="gcse-search"></div> -->
        </section>

        <!--HERO-->
        <section
          id="hero"
          class="d-flex flex-column justify-content-end mb-2"
          :style="{
            backgroundSize: 'cover',
            backgroundColor: '#8436FF',
            height: `${selectedCategory.heroImg ? '254px' : '126px'}`,
            backgroundImage: `url('${selectedCategory.heroImg}')`,
          }"
          v-if="
            (selectedCategory.length !== 0 &&
              this.searchedString === undefined &&
              !$router.currentRoute._value.fullPath.includes('?q=') &&
              searchedString != '') ||
            this.searchedString === ''
          "
        >
          <div id="herocontent">
            <h5 v-if="selectedCategory.categoryTitle">
              {{ UpperCase(selectedCategory.categoryTitle) }}
            </h5>
            <h1
              :style="
                selectedCategory.subdivisionTitle !== undefined &&
                isLongerThan15Chars(selectedCategory.subdivisionTitle.length)
                  ? 'font-size:smaller'
                  : 'font-size:inherit'
              "
            >
              {{ UpperCase(selectedCategory.subdivisionTitle) }}
            </h1>
          </div>
        </section>

        <p
          v-if="selectedCategory.message"
          class="text-center mt-lg-5"
          id="categoryMessage"
        >
          {{ selectedCategory.message }}
        </p>

        <p
          v-if="
            $store.state.searchedString !== '' &&
            $router.currentRoute._value.fullPath.includes('?q=') &&
            searchedString != ''
          "
          class="googlesearchMessage"
        >
          <!-- U zocht voor <b>{{ $store.state.searchedString }}</b> -->
        </p>
        <!--TOOLS-->
        <div
          id="noresults"
          v-if="
            this.searchedTools.length === 0 && this.searchedString !== undefined
          "
        >
          Geen resultaten voor <b>{{ this.searchedString }}</b>
        </div>
        <section
          v-if="$router.currentRoute._value.fullPath.includes('?q=')"
          class="toolsContainer scrollable-85vh"
        >
          <div v-if="$router.currentRoute._value.fullPath.includes('?q=')">
            <GoogleSearchResults></GoogleSearchResults>
          </div>
        </section>
        <section
          v-else
          class="toolsContainer"
          :class="
            this.searchedString !== '' && this.searchedString !== undefined
              ? 'scrollable-85vh'
              : 'scrollable-65vh'
          "
        >
          <div
            v-if="
              (this.searchedString === '' &&
                !$router.currentRoute._value.fullPath.includes('?q=') &&
                searchedString == '') ||
              (this.searchedString === undefined &&
                this.selectedCategory !== undefined &&
                !$router.currentRoute._value.fullPath.includes('?q='))
            "
            class="gridlayout"
          >
            <n-message-provider>
              <item-template
                class="toolItem"
                v-for="tool in selectedCategory.tools"
                :tool="tool"
                :key="tool"
              />
            </n-message-provider>
          </div>
          <div
            class="gridlayout"
            v-if="
              (this.searchedString !== '' &&
                !$router.currentRoute._value.fullPath.includes('?q=')) ||
              searchedString
            "
          >
            <n-message-provider>
              <item-template
                class="toolItem"
                v-for="tool in this.searchedTools"
                :tool="tool"
                :key="tool"
              />
            </n-message-provider>
          </div>
        </section>
      </div>
    </section>

    <!--FOOTER-->
    <div :class="$store.state.screenMode === 'dark' ? 'dark' : ''">
      <a
        class="footer"
        id="poweredby"
        :href="$store.state.routing.yungoSite"
        target="_blank"
        >powered by
        <img
          v-if="$store.state.screenMode === 'dark'"
          class="mt-auto mb-auto"
          src="@/assets/alleen-y-white.png"
          alt="yungo logo" />
        <img
          v-else
          class="mt-auto mb-auto"
          src="@/assets/alleen-y.png"
          alt="yungo logo"
      /></a>
    </div>
  </div>
</template>

<script>
import { NMessageProvider } from "naive-ui";
import ItemTemplate from "./ItemTemplate";
import CenteredYungoFooter from "@/components/CenteredYungoFooter";
import GoogleSearchResults from "@/components/Home/GoogleSearch/GoogleSearchResults";
import GoogleSearchComponent from "@/components/Home/GoogleSearch/GoogleSearchComponent";
export default {
  name: "CategoryTemplate",
  props: {
    selectedCategory: Object,
    allTools: Object,
    searchedString: "",
  },
  data: function () {
    return {
      searchedTools: [],
    };
  },
  methods: {
    isLongerThan15Chars(str) {
      // if (str === undefined) return;
      str.length >= 15 ? true : false;
    },
    UpperCase(value) {
      if (value == undefined) return;
      return value.toUpperCase();
    },
    onSearchChange() {
      this.searchedTools = [];
      for (let tool of this.allTools) {
        if (
          tool.title.toLowerCase().includes(this.searchedString.toLowerCase())
        ) {
          this.searchedTools.push(tool);
        }
      }

      const unique = (value, index, self) => {
        return self.indexOf(value) === index;
      };
      this.searchedTools = this.searchedTools.filter(unique);
      this.searchedTools = this.searchedTools.sort(
        (a, b) =>
          a.websitePreview.localeCompare(b.websitePreview) &&
          a.title.localeCompare(b.title)
      );
    },
  },
  components: {
    ItemTemplate,
    CenteredYungoFooter,
    NMessageProvider,
    GoogleSearchResults,
    GoogleSearchComponent,
  },
  mounted() {},
};
</script>

<style scoped>
.dark #hero {
  box-shadow: 0 4px 15px #000000;
}

.dark #poweredby:hover {
  color: #6b539a !important;
}

.dark .fullContainerSelectedItem,
.dark #searchBtn,
.dark #searchBtn:focus {
  background-color: var(--yungo-dark-gray);
}

.dark #searchBtn,
.dark #noresults,
.dark .toolboxSearchContainer i,
.dark #categoryMessage,
.dark .googlesearchMessage {
  color: white;
}

#poweredby:hover {
  color: #26134b !important;
}

.footer {
  margin-top: 10px;
  padding-bottom: 50px !important;
  color: #8436ff !important;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  display: flex;
  justify-content: center;
  margin: auto;
}

* {
  animation: itemLoad 0.4s;
}

.gridlayout {
  display: grid;
  grid-template-columns: repeat(auto-fill, 320px);
  grid-gap: 1rem;
  list-style: none;
  height: auto;
  margin: 0 auto;
  justify-content: space-between;
}

.toolsContainer {
  border-radius: 30px;
}

.nospacings::after {
  content: "";
  flex: auto;
}

#poweredby:hover {
  text-decoration: none;
}

#poweredby {
  color: var(--yungo);
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 15px;
}

#poweredby img {
  margin-left: 2px;
  height: 22px;
  width: auto;
  margin-top: -4px !important;
}

.scrollable-85vh {
  min-height: 40vh;
  max-height: 85vh;
  /* or any value */
  overflow-y: auto;
}

.scrollable-65vh {
  height: 65vh;
  /* or any value */
  overflow-y: auto;
}

.gsc-search-box {
  width: 300px;
}

:deep(button#googleSearchbtn) {
  margin-top: 0 !important;
}

@keyframes itemLoad {
  50% {
    opacity: 50%;
    display: block;
  }

  100% {
    opacity: 100%;
  }
}

.fullContainerSelectedItem {
  background-color: #f9f9f9;
  border-radius: 20px;
  height: auto;
}

#searchBtn {
  box-sizing: border-box;
  height: 44px;
  width: 350px;
  border: 1px solid #c0c0c0;
  border-radius: 15px;
  outline: none;
  background-color: #f9f9f9;
}

#searchBtn:focus {
  background-color: white;
}

#searchBtn[placeholder] {
  padding-left: 10px;
}

#hero {
  animation: itemLoad 0.8s !important;
  height: 254px;
  /* width: 95vw; */
  background-color: linear-gradient(
    500deg,
    rgb(135, 110, 255) 50%,
    rgba(0, 0, 0, 1.55) 0%,
    rgba(0, 0, 0, 1) 0%
  );
  border-radius: 30px;
}

#hero h1,
h5 {
  color: white;
  margin: 0 !important;
}

#hero h1 {
  height: 42px;
  color: #ffffff;
  font-size: 30px;
  letter-spacing: 0;
  line-height: 42px;
}

#hero h5 {
  height: 26px;
  width: 254px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
}

#herocontent {
  padding: 35px;
}

.toolboxSearchContainer i {
  margin-left: -30px;
}

.toolboxSearchContainer {
  margin-right: 18px;
}

@media only screen and (max-width: 1200px) {
  .searchSection {
    flex-wrap: wrap;
  }

  .toolboxSearchContainer {
    width: 100%;
    margin-right: 0;
  }

  #searchBtn {
    width: 100% !important;
  }

  .toolboxSearchContainer {
    margin-right: 0;
    margin-top: 10px;
  }
}

@media only screen and (max-width: 1034px) {
  .gridlayout {
    display: block !important;
  }
}

@media only screen and (max-width: 992px) {
  .toolboxSearchContainer,
  .searchCompContainer {
    width: 45% !important;
  }

  .gridlayout {
    grid-template-columns: repeat(auto-fill, 312px);
  }

  .homepageContainer .w-25 {
    margin-right: 50px;
  }

  ::-webkit-input-placeholder {
    font-size: 14px;
  }

  #categoryMessage {
    padding-top: 20px;
  }

  #hero h1 {
    line-height: inherit;
  }

  .searchCompContainer {
    margin-top: auto;
  }
}

@media only screen and (max-width: 700px) {
  #hero {
    height: 126px !important;
  }
  #herocontent {
    padding-left: 35px;
    padding-bottom: 23px;
  }
  .gridlayout {
    display: flex;
    flex-direction: column;
  }

  .mobileWidth {
    margin: 1rem !important;
  }

  #hero h1 {
    font-size: 14px !important;
    padding-top: 10px;
  }

  .searchSection {
    flex-wrap: wrap;
  }

  .toolboxSearchContainer,
  .searchCompContainer {
    width: 100% !important;
  }

  input#searchInput::placeholder {
    font-size: 14px !important;
  }

  #hero {
    height: 126px !important;
  }

  #herocontent {
    padding: inherit;
    padding-left: 35px;
    padding-bottom: 20px;
  }
}
</style>